var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-header"},[_c('nav',[_c('router-link',{staticClass:"button",attrs:{"to":"/Login"}},[_vm._v("Returning User Log in")]),_c('router-link',{staticClass:"button",attrs:{"to":"/about"}},[_vm._v("About the Program")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }